<wlcm-button size="small" styleType="compact" (clicked)="picker.reset()">Reset</wlcm-button>

<wlcm-button size="small" (clicked)="picker.apply()" [isDisabled]="!picker.isComplete()">Apply</wlcm-button>
